import { SportType } from 'modules/core/domain/enums/sport-type';
import { Board, Template } from 'modules/core/domain/interfaces/supabase/overlay/entity';
import { sanitizeFileName } from 'shared/utils/sanitize-file-name';
import {
  BOARD_TEMPLATE_FILE_FORMAT,
  BOARD_TEMPLATE_FILE_SUFFIX,
  BOARD_TEMPLATE_FILE_VERSION,
  BoardTemplateFile,
  BoardTemplateFileBoard,
} from './board-template-file';

export type BoardTemplateFileSource = Pick<Template, 'name' | 'sportType' | 'resolution'>;

export type BoardFileSource = Pick<Board, 'name' | 'version' | 'type' | 'events' | 'duration' | 'order' | 'objects'>;

interface BuildBoardTemplateFileOptions {
  origin: string;
  exportedAt: string;
}

export function toBoardTemplateFileBoard(board: BoardFileSource): BoardTemplateFileBoard {
  return {
    name: board.name,
    version: board.version,
    type: board.type,
    events: [...board.events],
    duration: board.duration,
    order: board.order,
    objects: board.objects,
  };
}

/** The whole broadcast template with its boards, in the given order. */
export function buildBoardTemplateFile(
  template: BoardTemplateFileSource,
  boards: readonly BoardFileSource[],
  { origin, exportedAt }: BuildBoardTemplateFileOptions,
): BoardTemplateFile {
  return {
    format: BOARD_TEMPLATE_FILE_FORMAT,
    formatVersion: BOARD_TEMPLATE_FILE_VERSION,
    exportedAt,
    source: { origin },
    template: {
      name: template.name,
      // Lower case like `SportType`: some stored templates say `FOOTBALL` (see the parser).
      sportType: String(template.sportType).toLowerCase() as SportType,
      resolution: { width: template.resolution.width, height: template.resolution.height },
    },
    boards: boards.map(toBoardTemplateFileBoard),
  };
}

/** `<template name>.imgame-board-template.json`. */
export function boardTemplateFileName(template: Pick<Template, 'name'>): string {
  return `${sanitizeFileName(template.name)}${BOARD_TEMPLATE_FILE_SUFFIX}`;
}

/** Pretty-printed (indent 2): the file is meant to be opened and edited by hand. */
export function serializeBoardTemplateFile(file: BoardTemplateFile): string {
  return JSON.stringify(file, null, 2);
}
